import React, { useState } from 'react';
import { Collapse, useMediaQuery } from '@mui/material';
import { RotatingLines } from 'react-loader-spinner';
import clsx from 'clsx';

import Icon from '../../icons/Icon';

import scss from './CollapsedButton.module.scss';
import CommonTooltip from '../common-tooltip/CommonTooltip';

export const COLLAPSED_BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
  ICON: 'icon',
  TABLE_ROW: 'table-row',
};

export const COLLAPSED_BUTTON_SIZES = {
  EXTRA_SMALL: 'extra-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const COLLAPSED_BUTTON_LOADER_SIZES = {
  [COLLAPSED_BUTTON_SIZES.EXTRA_SMALL]: { height: 12, width: 24 },
  [COLLAPSED_BUTTON_SIZES.SMALL]: { height: 13, width: 30 },
  [COLLAPSED_BUTTON_SIZES.MEDIUM]: { height: 15, width: 40 },
  [COLLAPSED_BUTTON_SIZES.LARGE]: { height: 17, width: 46 },
};

function CollapsedButton({
  onClick,
  isLoading,
  icon: IconComponent,
  label,
  type = COLLAPSED_BUTTON_TYPES.PRIMARY,
  size = COLLAPSED_BUTTON_SIZES.MEDIUM,
  tooltip,

  maxWidth,
  disabled,
  htmlFor,
  form,
  value,
  isStrokeIcon = false,
  disableOpenOnHover = false,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useMediaQuery('(max-width: 600px)');
  const loaderSize =
    COLLAPSED_BUTTON_LOADER_SIZES[size] ?? COLLAPSED_BUTTON_LOADER_SIZES[COLLAPSED_BUTTON_SIZES.MEDIUM];

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    onClick?.(e);
  };

  return (
    <CommonTooltip title={tooltip}>
      <button
        type='button'
        className={clsx(
          scss.collapsedButton,
          scss[`collapsedButton_style--${type}`],
          scss[`collapsedButton_size--${size}`],
        )}
        onClick={handleClick}
        disabled={disabled}
        form={form}
        value={value}
        htmlFor={htmlFor}
        style={maxWidth ? { maxWidth } : undefined}
        onMouseEnter={() => !disableOpenOnHover && setIsOpen(true)}
        onMouseLeave={() => !disableOpenOnHover && setIsOpen(false)}>
        {isLoading ? (
          <RotatingLines height={loaderSize.height} width={loaderSize.width} strokeColor='currentColor' />
        ) : (
          <Icon
            icon={IconComponent}
            className={clsx(scss[`collapsedButton_icon--${isStrokeIcon ? 'stroke' : 'fill'}`])}
            disableCommonColors
          />
        )}
        {label ? (
          <Collapse in={!isMobile ? isOpen : true} orientation='horizontal'>
            <span className={scss.saveButtonText}>{label}</span>
          </Collapse>
        ) : null}
      </button>
    </CommonTooltip>
  );
}

export default CollapsedButton;
